module.exports = __webpack_public_path__ + "img/topBtn.8bed7c0e.webp";